import { render, staticRenderFns } from "./PrintSummaryAccountsSellers.vue?vue&type=template&id=13426edf&scoped=true"
import script from "./PrintSummaryAccountsSellers.vue?vue&type=script&lang=js"
export * from "./PrintSummaryAccountsSellers.vue?vue&type=script&lang=js"
import style0 from "./PrintSummaryAccountsSellers.vue?vue&type=style&index=0&id=13426edf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13426edf",
  null
  
)

export default component.exports